export const INVESTOR_DAY_ORDERING = 'investor_day_ordering';
export const CATERING_MENU_SEARCH = 'catering_menu_search';
